export const DOC_MOVE_WS_EVENT = 'DOC_MOVE_WS_EVENT';
export const DOC_MOVE_CLEAR_ALERT = 'DOC_MOVE_CLEAR_ALERT';
